/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, Theme, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import MyTable, { TableRow } from "../../../components/MyTable";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { TableHeadRows } from "../../../components/MyTable/TableHead";
// import { searchApprovalGroupsCompanies } from "../../../store/slices/userRequests";
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
// import { deleteEmployees, getLicenses } from "../../../api/s10OrganizationApi";
import { getUserRegistrationTypeName, License } from "../../../interfaces/auth.interface";
import MySnackbar from "../../../components/MySnackbar";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Chip } from "@mui/material";
import { getS10Licenses, getS10LicenseUsers } from "../../../api/s10OrganizationApi";

const tabOptions = [{
    label: "Licencias",
}, {
    label: "Colaboradores Asignados",
}]

const LicenseCard = (row: License, theme: Theme) => {
    const isActive = row.UsersNumber > 1;
    const usagePercentage = row.UsersNumber 
        ? (row.UsersActive / row.UsersNumber) * 100
        : 0;
    
    return (
        <CardContent style={{ padding: "1rem" }}>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        component="div"
                    >
                        {row.ModuleName}
                    </Typography>
                    <Chip 
                        label={isActive ? "Activa" : "Inactiva"} 
                        size="small"
                        sx={{
                            backgroundColor: isActive 
                                ? theme.s10palette.S10Greengreen500
                                : theme.s10palette.S10Redred500,
                            color: 'white',
                            marginBottom: '0.5rem'
                        }}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                        Tipo de licencia: {getUserRegistrationTypeName(row.UserRegistration)}
                    </Typography>
                </Grid>
                {/* <Grid item xs={12}>  
                    <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                        Adquisición:
                    </Typography>
                    <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                        {new Date(row.acquisitionDate).toLocaleDateString()}
                    </Typography>
                </Grid> */}
                {/* <Grid item xs={12}>  
                    <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                        Expiración:
                    </Typography>
                    <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                        {new Date(row.expirationDate).toLocaleDateString()}
                    </Typography>
                </Grid> */}
                
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        <FolderSpecialIcon sx={{ fontSize: '1rem', verticalAlign: 'middle', mr: 0.5 }} />
                        Licencias {row.UserRegistration === 1 ? ` disponibles: ${row.UsersNumber}` : 'Ilimitadas'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        <PersonOutlineIcon sx={{ fontSize: '1rem', verticalAlign: 'middle', mr: 0.5 }} />
                        Licencias en uso {row.UsersActive}
                    </Typography>
                    {row.UserRegistration === 1 && <>
                        <div style={{
                            width: '100%',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '4px',
                            marginTop: '4px'
                        }}>
                            <div style={{
                                width: `${usagePercentage}%`,
                                height: '8px',
                                backgroundColor: usagePercentage > 90 
                                    ? theme.s10palette.S10Redred500 
                                    : usagePercentage > 70 
                                    ? theme.s10palette.S10Greengreen500 
                                    : theme.s10palette.S10Greengreen500,
                                borderRadius: '4px'
                            }} />
                        </div>
                        <Typography variant="caption" color="text.secondary">
                            {usagePercentage.toFixed(1)}% de capacidad utilizada
                        </Typography>
                    </>}
                    
                </Grid>
            </Grid>
        </CardContent>
    );
};

const LicensesView = () => {
    const theme = useTheme();
    
    const [tabOptionSelected, setTabOptionSelected] = useState(0);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    // const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedLicense, setSelectedLicense] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    
    const [licenses, setLicenses] = useState<License[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    // const [openEmployeesModal, setOpenEmployeesModal] = useState<boolean>(false);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [selectedItemsLabel, setSelectedItemsLabel] = useState<string[]>([]);
    const [snackBarMessage, setSnackBarMessage] = useState<any | undefined>();
    const [timeToResetSelectedItems, setTimeToResetSelectedItems] = useState<string>("");

    const licenseHeader = [{
        label: "ID",
        rowKeyName: "SecurityModuleId",
    }, {
        label: "Nombre",
        rowKeyName: "ModuleName",
    }, {
        label: "Estado",
        rowKeyName: "status",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return  row.UsersNumber > 1 ? 'Activa' : 'Inactiva';
        },
       
    }, {
        label: "Usuarios Activos",
        rowKeyName: "UsersActive",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return `${row.assignedUsers}/${row.maxUsers}`;
        },
    }, {
        label: "Licencias disponibles",
        rowKeyName: "acquisitionDate",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return row.UserRegistration === 1 
                ? ` disponibles: ${row.UsersNumber}` 
                : 'Ilimitadas';
        },
    },];

    const employeeHeader = [{
        label: "Nombre",
        rowKeyName: "Name",
    }, {
        label: "Email",
        rowKeyName: "UserName",
    }, {
        label: "Role",
        rowKeyName: "RoleName",
    }, {
        label: "Estado",
        rowKeyName: "status",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return row.IsActive
                ? 'Activa'
                : 'Inactiva';
        },
    }];

    // const handleCloseModal = ({ success, msg }: { success?: boolean, msg?: string }) => {
    //     setOpenEmployeesModal(false);
    //     if (success !== undefined && msg) {
    //         setSnackBarMessage({ success, msg });
            
    //         if (success) {
    //             if (tabOptionSelected === 1 && selectedLicense) {
    //                 getS10LicenseUsers(selectedLicense).then(r => {
    //                     console.log('r.data', r.data)
    //                     setEmployees(r.data || []);
    //                 }).finally(() => {
    //                     setLoading(false);
    //                 });
    //             }
    //         }
    //     }
    // };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabOptionSelected(newValue);
        setSelectedItems([]);
        setTimeToResetSelectedItems(new Date().toISOString());
    };

    const handleDeleteAction = async (): Promise<boolean> => {
        if (tabOptionSelected === 1) {
            setSnackBarMessage({
                success: true,
                msg: "Colaboradores desasignados exitosamente"
            });
            return true;
        }
        return false;
    };

    const handleResetSelectedItems = () => {
        setTimeToResetSelectedItems(new Date().toISOString());
        setSelectedItems([]);
    };

    const handleDeleteItems = () => {
        const data = tabOptionSelected === 0 ? licenses : employees;
        const selectorFieldName = tabOptionSelected === 0 ? "id" : "id";
        
        const selectedItemsData = (data as any)
            .filter((d: any) => selectedItems.includes(d[selectorFieldName]))
            .map((m: any) => tabOptionSelected === 0 
                ? `Licencia ${m.name}` 
                : `Colaborador ${m.name}`);
        
        setSelectedItemsLabel(selectedItemsData);
        setOpenDeleteModal(true);
    };

    useEffect(() => {
        
        handleResetSelectedItems();
        
        if (tabOptionSelected === 0 && !loading && !licenses.length) {
            setLoading(true);
            getS10Licenses().then(r => {
                setLicenses(r.data || []);
            }).finally(() => {
                setLoading(false);
            })
        } else if (tabOptionSelected === 1 && selectedLicense) {
            getS10LicenseUsers(selectedLicense).then(r => {
                console.log('r.data', r.data)
                setEmployees(r.data || []);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [tabOptionSelected, selectedLicense]);

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >
                <Grid container spacing={2} marginBottom="1.5rem">
                    {/* {companies.length > 0 && (
                        <Grid item>
                            <FormControl style={{ minWidth: "15rem" }}>
                                <InputLabel id="select-company-label">Empresa</InputLabel>
                                <Select
                                    labelId="select-company-label"
                                    id="select-company"
                                    label="Empresa"
                                    onChange={(event) => {
                                        setSelectedCompany(event.target.value);
                                        if (tabOptionSelected === 1) {
                                            setSelectedLicense("");
                                        }
                                    }}
                                    value={selectedCompany}
                                    style={{ height: "2.5rem", border: "none", backgroundColor: "white" }}
                                >
                                    {companies?.map((item, i) => (
                                        <MenuItem key={i} value={item.RUC}>
                                            {item.Descripcion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )} */}
                    
                    {tabOptionSelected === 1 && licenses.length > 0 && (
                        <Grid item>
                            <FormControl style={{ minWidth: "20rem" }}>
                                <InputLabel id="select-license-label">Licencia</InputLabel>
                                <Select
                                    labelId="select-license-label"
                                    id="select-license"
                                    label="Licencia"
                                    onChange={(event) => {
                                        setSelectedLicense(event.target.value);
                                    }}
                                    value={`${selectedLicense}`}
                                    style={{ height: "2.5rem", border: "none", backgroundColor: "white" }}
                                >
                                    {licenses?.map((item, i) => (
                                        <MenuItem key={i} value={item.Id}>
                                            {item.ModuleName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Grid>
                
                <Grid sx={{ borderBottom: 1, borderColor: '#E8E8E8' }}>
                    <Tabs value={tabOptionSelected} onChange={handleChange} aria-label="license-management-tabs">
                        {tabOptions.map((t, i) => (
                            <Tab 
                                key={i} 
                                label={t.label} 
                                style={{
                                    color: i === tabOptionSelected 
                                        ? `${theme.s10palette.S10Blueblue600}` 
                                        : `${theme.s10palette.S10Greygrey300}`,
                                    fontFamily: 'Roboto',
                                    fontSize: '1rem',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: 'normal',
                                }} 
                            />
                        ))}
                    </Tabs>
                </Grid>
                
                <MyTable
                    key={`tab-${tabOptionSelected}`}
                    tableHeadRows={
                        tabOptionSelected === 0 ? licenseHeader : employeeHeader
                    }
                    tableRows={
                        tabOptionSelected === 0 ? licenses : employees
                    }
                    selectionOptions={{
                        selectorFieldName: tabOptionSelected === 0 ? "SecurityModuleId" : "SecurityUserId",
                        setSelectedItems: (values) => {
                            const finalLicense = tabOptionSelected === 0 
                                ? values.splice(-1)
                                : values
                            if (tabOptionSelected === 0 && finalLicense.length) {
                                const selectedLicence = licenses.find(l => `${l.SecurityModuleId}` === `${finalLicense[0]}`);
                                setSelectedLicense(`${selectedLicence?.Id}` || '0');
                                setTabOptionSelected(1)
                            }
                            setSelectedItems(finalLicense);
                        },
                        timeToResetSelectedItems: timeToResetSelectedItems
                    }}
                    cardComponent={
                        tabOptionSelected === 0
                            ? {
                                cardContent: (row) => LicenseCard(row as License, theme),
                            }
                            : {
                                imageData: {
                                    descriptionRowName: "Name",
                                },
                                className:  (row) => row.IsActive
                                                        ? "coupon-appoved-completed" 
                                                        : "coupon-rejected",
                                cardContent: (row) => (
                                    <CardContent style={{ padding: "0 1rem 1rem 55px", position: 'relative' }}>
                                        <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                                            {row.UserName}
                                        </Typography>
                                        <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                                            Rol: {row.RoleName}
                                        </Typography>
                                        <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                                            Estado: {row.IsActive ? "Activa" : "Inactiva"}
                                        </Typography>
                                    </CardContent>
                                ),
                            }
                    }
                    loading={loading}
                    hiddenSearchInput={true}
                    customItemOptionBar={tabOptionSelected === 0 ? undefined : () => (
                        <Button 
                            variant="outlined"
                            color="error"
                            style={{ backgroundColor: "#F8E6E6" }}
                            disabled={selectedItems.length === 0}
                            onClick={handleDeleteItems}
                            startIcon={<DeleteOutlinedIcon />}
                        >
                            Desasignar
                        </Button>
                    )}
                    tableOptionsBar={{
                        useDrawer: false,
                    }}
                />
            </Paper>
            
            <Dialog
                open={openDeleteModal}
                aria-labelledby="responsive-dialog-title"
                style={{ width: "100%" }}
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{ padding: "0", margin: "2rem", textAlign: "center" }} 
                    variant="h5"
                >
                    ¿Seguro de desasignar los colaboradores seleccionados?
                </DialogTitle>
                <DialogContent style={{ width: "100%", textAlign: "center" }}>
                    <Grid container spacing="1.5rem">
                        <Grid item xs={12}>
                            Se procederá a desasignar:
                        </Grid>
                    </Grid>
                    <List dense style={{ listStyleType: 'disc', padding: '0 20px' }}>
                        {selectedItemsLabel.map((item, index) => (
                            <ListItem key={index} style={{ padding: '5px 0' }}>
                                <ListItemIcon style={{ minWidth: 0 }}>
                                    <ArrowRightIcon />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                style={{ width: "8rem" }}
                                startIcon={<CloseIcon style={{ height: "1rem" }} />}
                                onClick={() => setOpenDeleteModal(false)}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <Button 
                                variant="contained" 
                                color="error"
                                style={{ width: "8rem" }}
                                startIcon={<CheckIcon style={{ height: "1rem" }} />}
                                onClick={async () => {
                                    const reset = await handleDeleteAction();
                                    if (reset) {
                                        handleResetSelectedItems();
                                    }
                                    setOpenDeleteModal(false);
                                }}
                            >
                                Confirmar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            
            {/* {openEmployeesModal && (
                <EmployeesModal 
                    ruc={selectedCompany} 
                    approvalGroupId={selectedLicense} 
                    handleCloseModal={handleCloseModal}
                    action="addEmployees"
                />
            )} */}
            
            {snackBarMessage && (
                <MySnackbar 
                    msg={snackBarMessage.msg} 
                    severity={snackBarMessage.success ? 'success' : 'error'}
                    onClose={() => setSnackBarMessage(undefined)}
                    open={true}
                />
            )}
        </Grid>
    );
};

export default LicensesView;